const mobileRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;

const tabletRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i;

export function isMobile(opts: { tablet?: boolean, featureDetect?: boolean} = {}) {
	const ua = navigator.userAgent;

	let result = opts.tablet ? tabletRE.test(ua) : mobileRE.test(ua);

	if (
		!result &&
		opts.tablet &&
		opts.featureDetect &&
		navigator &&
		navigator.maxTouchPoints > 1 &&
		ua.indexOf('Macintosh') !== -1 &&
		ua.indexOf('Safari') !== -1
	) {
		result = true;
	}

	return result
}

export function isDesktop() {
	return !isMobile();
}
